export const HOME = '/';
export const LOGIN = '/login';
export const PROJECT_LIST = '/project-list';
export const SINGLE_PROJECT = '/project-list/:id';
export const SINGLE_PATIENT = '/patient/:id';
